module.exports = __webpack_public_path__ + "img/frame (212).e5d24e6d.jpg";